// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout_v_xmSfQ{padding:20px;max-width:1350px;margin:0 auto;position:relative}`, "",{"version":3,"sources":["webpack://./components/layout/layout.module.scss"],"names":[],"mappings":"AAAA,gBACC,YAAA,CACA,gBAAA,CACA,aAAA,CACA,iBAAA","sourcesContent":[".layout {\n\tpadding: 20px;\n\tmax-width: 1350px;\n\tmargin: 0 auto;\n\tposition: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export var layout = `layout_v_xmSfQ`;
export default ___CSS_LOADER_EXPORT___;
